import { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from 'react-router';
import { CustomButton } from './StyledComponents';
import { Col, Container, Row } from 'react-bootstrap';
import LocalizedStrings from 'react-localization';

import { PendingView } from './PendingView';
import { JobDetailsView } from './JobDetailsView';
import { addCss, getColors, getFont, getHeaderUrl, getLogoUrl, useQuery } from '../Utils';
import SettingsContext from '../SettingsContext';
import JobContext from '../JobContext';
import { JobProvider } from '../JobProvider';
import { JobList, StatisticService, ClientLanguage, getClientLanguageAsString } from '../Api';
import { ErrorView } from './ErrorView';

let locStrings = new LocalizedStrings({
    de:
    {
        messageSettingsLoaded:"Einstellungen werden geladen...",
        messageJobPostingLoaded:"Stellenausschreibung wird geladen...",
        back: "Zurück",
    },
    en:
    {
        messageSettingsLoaded:"Settings are loaded...",
        messageJobPostingLoaded:"Job posting is loaded...",
        back: "Back",
    }
});

export const JobView = () => {
    const query = useQuery();
    const previewMode = query.get("preview") !== null && query.get("preview") === "true";
    const { tenant, listName, id } = useParams();
    const { isLoading: isSettingsLoading, settings } = useContext(SettingsContext);

    let navigate = useNavigate();

    function updateCounters(counterNames: string[]) {
        if (counterNames.length === 0) return;

        let counter = counterNames.shift();

        // force updateCounter calls to be processed synchronously
        StatisticService.updateCounter(tenant, id, counter).then(result => {
            updateCounters(counterNames);
            console.log();
        }).catch(() => {
            console.log();
        });
    }

    const onBackClick = () => {
        navigate(`/${tenant}/${listName}`, {});
    }

    const onApplyClick = (jobId: string) => {
        // force updateCounter calls (to "FormViews" and "FormApplyNowCount") to be processed synchronously
        updateCounters(["FormViews","FormApplyNowCount"]);
        navigate(`/${tenant}/${listName}/${jobId}/form`, {});
    }

    function getClientLanguage(jobList: JobList): string { 
        return getClientLanguageAsString(jobList.clientLanguage); 
    } 
    
    function setLanguage(jobList: JobList): void {
        switch(jobList.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    if (isSettingsLoading) {
        if (!previewMode) {
            updateCounters(["FormJobCount"]);
        }
        return <PendingView message={locStrings.messageSettingsLoaded} clientLanguage={ClientLanguage.BrowserSetting}></PendingView>;
    }

    return (
        <JobProvider>
            <JobContext.Consumer>
                {({ isLoading, jobList, job,error }) => isLoading ? <PendingView message={locStrings.messageJobPostingLoaded} clientLanguage={jobList?.clientLanguage}></PendingView> :
                (error) ? <ErrorView message={error.message} description={error.description}></ErrorView>:
                (
                    <>
                        {jobList.cssKey && addCss(`${settings.imagesUrl}/${tenant}.${jobList.cssKey}`)}
                        {setLanguage(jobList)}
                        <Container fluid>
                            <Container style={{ maxWidth: "800px", backgroundColor: "white", fontFamily: getFont(jobList, job) }}>
                                <Row>
                                    <Col md={12} style={{ display: "flex", justifyContent: "right" }}>
                                    </Col>
                                    <Col md={12}>
                                        {jobList.directIntegrationIframe &&
                                            <Row>
                                                <Col lg={12}>
                                                    <div className={"ListDetailsBackButton"} style={{ paddingTop: "30px", display: "flex", justifyContent: "left" }}>
                                                        <CustomButton onClick={onBackClick} colors={getColors(jobList, job)}>{locStrings.back}</CustomButton>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }
                                        {jobList.directIntegrationIframe && getHeaderUrl(jobList, job, settings) &&
                                            <Row>
                                                <Col lg={12}>
                                                    <div style={{ paddingTop: "30px", display: "flex", justifyContent: "left" }}>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }
                                        <JobDetailsView
                                            previewMode={previewMode}
                                            job={job}
                                            colors={getColors(jobList, job)}
                                            logoUrl={getLogoUrl(jobList, job, settings)}
                                            headerUrl={getHeaderUrl(jobList, job, settings)}
                                            listId={jobList?.id}
                                            fontFamily={getFont(jobList, job)}
                                            onApplyClick={onApplyClick}
                                            legalNoticeUrl={jobList.legalNoticeUrl}
                                            dataSecurityUrl={jobList.dataSecurityUrl}
                                            formalAddressPronoun={jobList.formalAddressPronoun} 
                                            subtitleOnJobPosting={jobList.subtitleOnJobPosting} 
                                            customlink1={jobList.customLink1}
                                            customlink2={jobList.customLink2}
                                            customlink3={jobList.customLink3}
                                            customlink4={jobList.customLink4}
                                            customlink5={jobList.customLink5}
                                            customForm={jobList.customForm}
                                            directIntegrationIframe={jobList.directIntegrationIframe}
                                            submitApplicationSuccessHeader={jobList.submitApplicationSuccessHeader}
                                            submitApplicationText={jobList.submitApplicationText}
                                            clientLanguage={jobList.clientLanguage}/>
                                    </Col>
                                </Row>
                            </Container>
                        </Container>
                        {/* <div>
                            {<small><b>Debug info: ClientLanguage: </b> {getClientLanguage(jobList)}</small>}
                        </div> */}
                    </>
                )}
            </JobContext.Consumer>
        </JobProvider>
    );
}
